<template>
  <div class="pb-30">
    <ContentSection skew="right" id="our-people" class="z-0 bg-regalblue-500 pb-16 pt-16">
      <div class="grid grid-cols-12 gap-4">
        <div class="col-span-12 sm:col-span-10">
          <h1 class="text-4xl text-white">End-User Licence Agreement (“Agreement”)</h1>
          <p class="pb-2 text-xl sm:text-2xl font-light text-white">
            Last Updated: 6th January 2021
          </p>
        </div>
      </div>
    </ContentSection>
    <ContentSection id="eula" skew="right" class="z-10 bg-white my-0 pt-16 pb-24">
      <div class="eula-wrap">
        <ol class="list-decimal">
          <li>
            <span>
              Please read this End-User License Agreement (the "Agreement") carefully before
              downloading, installing or using the
              <strong>
                Pipefish CI Synchronizer for Enterprise – Lansweeper On-Premise to ServiceNow
                Edition
              </strong>
              (the "Software").
            </span>
          </li>

          <li>
            <span>
              This Agreement is a legal agreement between you either an individual or as a
              representative of your organisational entity (the “Licensee”) and Pipefish Pty Ltd
              (the “Vendor”) and it governs the Licensee’s use of the Software made available by the
              Vendor.
            </span>
          </li>

          <li>
            <span>
              If you do not agree to the terms of this Agreement, do not download, install or use
              the Software.
            </span>
          </li>

          <h1 class="text-4xl">Acceptance</h1>

          <li>
            <span>
              All terms, conditions, obligations of this Agreement will deemed to be accepted by the
              Licensee (“Acceptance”) by downloading, installing or using the Software.
            </span>
          </li>

          <h1 class="text-4xl">Licence</h1>

          <li>
            <span>
              Under this Agreement, the Vendor grants the Licensee a revocable, non-exclusive,
              non-transferable, limited license to download, install and use the Software strictly
              in accordance with the terms of this Agreement.
            </span>
          </li>

          <li>
            <span>
              “Software” includes the executable computer programs and any related printed,
              electronic and online documentation and other files that may accompany the product.
            </span>
          </li>
          <li>
            <span>
              The Software is licensed, not sold, to the Licensee by the Vendor for use strictly in
              accordance with the terms of this Agreement.
            </span>
          </li>
          <li>
            <span>
              Title, copyright, intellectual property rights and distribution rights of the Software
              remain exclusively with the Vendor. Intellectual property rights include the look and
              feel of the Software. This agreement constitutes a licence for use only and is not in
              any way a transfer of ownership rights to the Software.
            </span>
          </li>
          <li>
            <span>
              The rights and obligations of this Agreement are personal rights granted to the
              Licensee only. The Licensee agrees not to, and not permit others to:

              <ul class="list-disc">
                <li>
                  <span>
                    license, sell, rent, lease, assign, distribute, transmit, host, outsource,
                    disclose or otherwise commercially exploit the Software or make the Software
                    available to any other person, legal entity or third party.
                  </span>
                </li>
                <li>
                  <span>
                    modify, make derivative works of, disassemble, decrypt, reverse compile or
                    reverse engineer any part of the Software.
                  </span>
                </li>
                <li>
                  <span>
                    remove, alter or obscure any proprietary notice (including any notice of
                    copyright or trademark) of the Vendor or its affiliates, partners, suppliers or
                    the licensors of the Software.
                  </span>
                </li>
              </ul>
            </span>
          </li>

          <li>
            <span>
              Failure to comply with any of the terms under the Licence section will be considered a
              material breach of this Agreement.
            </span>
          </li>

          <h1 class="text-4xl">Licence Fee</h1>

          <li>
            <span>
              The Software is provided free of charge to the Licensee. The installation or use of
              the Software is the full consideration for this Agreement.
            </span>
          </li>

          <h1 class="text-4xl">Your suggestions</h1>
          <li>
            <span>
              Any feedback, comments, ideas, improvements or suggestions (collectively,
              "Suggestions") provided by the Licensee to the Vendor with respect to the Software
              shall remain the sole and exclusive property of the Vendor.
            </span>
          </li>
          <li>
            <span>
              The Vendor shall be free to use, copy, modify, publish, or redistribute the
              Suggestions for any purpose and in any way without any credit or any compensation to
              the Licensee.
            </span>
          </li>

          <h1 class="text-4xl">Modifications to the Software</h1>

          <li>
            <span>
              The Vendor reserves the right to modify, suspend or discontinue, temporarily or
              permanently, the Software or any service to which it connects, with or without notice
              and without liability to the Licensee.
            </span>
          </li>

          <h1 class="text-4xl">Updates to the Software</h1>

          <li>
            <span>
              The Vendor may from time to time provide enhancements or improvements to the
              features/functionality of the Software, which may include patches, bug fixes, updates,
              upgrades and other modifications ("Updates").
            </span>
          </li>
          <li>
            <span>
              Updates may modify or delete certain features and/or functionalities of the Software.
              The Licensee agrees the Vendor has no obligation to:

              <ol class="list-lower-roman">
                <li><span>provide any Updates, or</span></li>
                <li>
                  <span>
                    continue to provide or enable any particular features and/or functionalities of
                    the Software to the Licensee.
                  </span>
                </li>
              </ol>
            </span>
          </li>
          <li>
            <span>
              The Licensee further agree that all Updates will be:
              <ol class="list-lower-roman">
                <li><span>deemed to constitute an integral part of the Software, and</span></li>
                <li><span>subject to the terms and conditions of this Agreement.</span></li>
              </ol>
            </span>
          </li>

          <h1 class="text-4xl">Term and Termination</h1>

          <li>
            <span>
              This Agreement shall remain in effect until terminated by the Vendor or the Licensee.
            </span>
          </li>
          <li>
            <span>
              The Vendor may, in its sole discretion, at any time and for any or no reason, suspend
              or terminate this Agreement with or without prior notice.
            </span>
          </li>
          <li>
            <span>
              This Agreement will terminate immediately, without prior notice from the Vendor, in
              the event the Licensee fails to comply with any provision of this Agreement or is in
              breach of this Agreement. The Licensee may also terminate this Agreement by deleting
              the Software and all copies thereof from all computer systems.
            </span>
          </li>
          <li>
            <span>
              Upon termination of this Agreement, the Licensee shall cease all use of the Software
              and delete all copies of the Software from all computer systems.
            </span>
          </li>
          <li>
            <span>
              Termination of this Agreement will not limit any of the Vendor’s rights or remedies at
              law or in equity in case of breach by the Licence (during the term of this Agreement)
              of any of the Licensee’s obligations under the present Agreement.
            </span>
          </li>

          <h1 class="text-4xl">Indemnification</h1>

          <li>
            <span>
              The Licensee agrees to indemnify and hold harmless the Vendor and its parents,
              subsidiaries, affiliates, officers, employees, agents, partners and licensors (if any)
              from any claim or demand, including reasonable attorneys' fees, due to or arising out
              of the Licensee’s:

              <ol class="list-lower-roman">
                <li><span>use of the Software;</span></li>
                <li><span>violation of this Agreement or any law or regulation; or</span></li>
                <li><span>violation of any right of a third party.</span></li>
              </ol>
            </span>
          </li>

          <h1 class="text-4xl">No warranties</h1>

          <li>
            <span>
              The Software is provided to the Licensee "AS IS" and "AS AVAILABLE" and with all
              faults and defects without warranty of any kind.
            </span>
          </li>
          <li>
            <span>
              To the maximum extent permitted under applicable law, the Vendor, on its own behalf
              and on behalf of its affiliates and its and their respective licensors and service
              providers, expressly disclaims all warranties, whether express, implied, statutory or
              otherwise, with respect to the Software, including all implied warranties of
              merchantability, fitness for a particular purpose, title and non-infringement, and
              warranties that may arise out of course of dealing, course of performance, usage or
              trade practice.
            </span>
          </li>
          <li>
            <span>
              Without limitation to the foregoing, the Vendor provides no warranty or undertaking,
              and makes no representation of any kind that the Software will meet the Licensee’s
              requirements, achieve any intended results, be compatible or work with any other
              software, applications, systems or services, operate without interruption, meet any
              performance or reliability standards or be error free or that any errors or defects
              can or will be corrected. Without limiting the foregoing, the Vendor makes any
              representation or warranty of any kind, express or implied:

              <ol class="list-lower-roman">
                <li>
                  <span>
                    as to the operation or availability of the Software, or the information,
                    content, and materials or products included thereon;
                  </span>
                </li>
                <li><span>that the Software will be uninterrupted or error-free;</span></li>
                <li>
                  <span>
                    as to the accuracy, reliability, or currency of any information or content
                    provided through the Software; or
                  </span>
                </li>
                <li>
                  <span>
                    that the Software, its servers, the content, or e-mails sent from or on behalf
                    of the Vendor are free of viruses, scripts, trojan horses, worms, malware,
                    timebombs or other harmful components.
                  </span>
                </li>
              </ol>
            </span>
          </li>
          <li>
            <span>
              Some jurisdictions do not allow the exclusion of or limitations on implied warranties
              or the limitations on the applicable statutory rights of a consumer, so some or all of
              the above exclusions and limitations may not apply to the Licensee.
            </span>
          </li>

          <h1 class="text-4xl">Limitation of Liability</h1>

          <li>
            <span>
              Notwithstanding any damages that you might incur, the entire liability of the Vendor
              and any of its suppliers under any provision of this Agreement and the Licensee’s
              exclusive remedy for all of the foregoing is $Nil (zero dollars).
            </span>
          </li>
          <li>
            <span>
              To the maximum extent permitted by applicable law, in no event shall the Vendor or its
              suppliers be liable for any special, incidental, indirect, or consequential damages
              whatsoever (including, but not limited to, damages for loss of profits, for loss of
              data or other information, for business interruption, for personal injury, for loss of
              privacy arising out of or in any way related to the use of or inability to use the
              Software, third-party software and/or third-party hardware used with the Software, or
              otherwise in connection with any provision of this Agreement), even if the Vendor or
              any supplier has been advised of the possibility of such damages and even if the
              remedy fails of its essential purpose.
            </span>
          </li>
          <li>
            <span>
              Some jurisdictions do not allow the exclusion or limitation of incidental or
              consequential damages, so the above limitation or exclusion may not apply to the
              Licensee.
            </span>
          </li>

          <h1 class="text-4xl">Severability</h1>

          <li>
            <span>
              If any provision of this Agreement is held to be unenforceable or invalid, such
              provision will be changed and interpreted to accomplish the objectives of such
              provision to the greatest extent possible under applicable law and the remaining
              provisions will continue in full force and effect.
            </span>
          </li>

          <h1 class="text-4xl">Waiver</h1>

          <li>
            <span>
              Except as provided herein, the failure to exercise a right or to require performance
              of an obligation under this Agreement shall not effect a party's ability to exercise
              such right or require such performance at any time thereafter nor shall be the waiver
              of a breach constitute waiver of any subsequent breach.
            </span>
          </li>

          <h1 class="text-4xl">Amendments to this Agreement</h1>

          <li>
            <span>
              The Vendor reserves the right, at its sole discretion, to modify or replace this
              Agreement at any time. If a revision is material, the Vendor will provide at least 30
              days' notice prior to any new terms taking effect. What constitutes a material change
              will be determined at the Vendor’s sole discretion.
            </span>
          </li>
          <li>
            <span>
              By continuing to access or use of the Software after any revisions become effective,
              the Licensee agrees to be bound by the revised terms. If the Licensee does not agree
              to the new terms, the Licensee are no longer authorized to use the Software.
            </span>
          </li>

          <h1 class="text-4xl">Governing Law</h1>

          <li>
            <span>
              The Parties to this Agreement submit to the jurisdiction of the courts of the State of
              Queensland for the enforcement of this Agreement or any arbitration award or decision
              arising from this Agreement. This Agreement will be enforced or construed according to
              the laws of the State of Queensland.
            </span>
          </li>
          <li>
            <span>
              The Licensee’s use of the Software may also be subject to other local, state,
              national, or international laws.
            </span>
          </li>

          <h1 class="text-4xl">Contact Information and Notices</h1>

          <li>
            <span>If you have any questions about this Agreement, please contact the Vendor.</span>
          </li>
          <li>
            <span>
              All notices to the Vendor under this Agreement are to be provided at the registered
              address for Pipefish Pty Ltd in Queensland, Australia.
            </span>
          </li>

          <h1 class="text-4xl">Miscellaneous</h1>

          <li>
            <span>
              This Agreement does not create or imply any relationship in agency or partnership
              between the Vendor and the Licensee.
            </span>
          </li>
          <li>
            <span>
              Headings are inserted for the convenience of the parties only and not to be considered
              when interpreting this Agreement. Words in the singular mean and include the plural
              and vice versa. Words in the masculine gender include the feminine gender and vice
              versa. Words in the neuter gender include the masculine gender and the feminine gender
              and vice versa.
            </span>
          </li>
          <li>
            <span>
              If any term, covenant, condition or provision of this Agreement is held by a court of
              competent jurisdiction to be invalid, void or unenforceable, it is the parties’ intent
              that such provision be reduced in scope by the court only to the extent deemed
              necessary by that court to render the provision reasonable and enforceable and the
              remainder of the provision of this Agreement will in no way be affected, impaired or
              invalidated as a result.
            </span>
          </li>
          <li>
            <span>
              The Agreement constitutes the entire agreement between the Licensee and the Vendor
              regarding the Licensee’s use of the Software and supersedes all prior and
              contemporaneous written or oral agreements between the Licensee and the Vendor. Only
              the written terms of this Agreement will bind the parties.
            </span>
          </li>
          <li>
            <span>
              This Agreement and the terms and conditions contained in this Agreement apply to and
              are binding upon the Vendor’s successors and assigns.
            </span>
          </li>
          <li>
            <span>
              The Licensee may be subject to additional terms and conditions that apply upon use or
              purchase other services from the Vendor, which will be provided to the Licensee at the
              time of such use or purchase.
            </span>
          </li>
        </ol>
      </div>
    </ContentSection>
  </div>
</template>

<script>
import ContentSection from '@/components/ContentSection.vue';

export default {
  name: 'EULA',
  components: {
    ContentSection
  }
};
</script>

<style lang="scss">
.eula-wrap li {
  font-size: 0.75rem;
  padding: 0.5rem;
}

.eula-wrap ul,
ol,
li {
  padding-left: 10px;
}

.eula-wrap li::marker {
  font-size: 1rem;
}

.eula-wrap h1 {
  margin-top: 1.75rem;
  margin-bottom: 1rem;
}

.eula-wrap span {
  font-size: 1rem;
}
</style>
